import type { IconNode } from '../types';

/**
 * @name iron
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA3aC4wMSIgLz4KICA8cGF0aCBkPSJNNiAxMWguMDEiIC8+CiAgPHBhdGggZD0iTTEwIDExaC4wMSIgLz4KICA8cGF0aCBkPSJNNiAxNWguMDEiIC8+CiAgPHBhdGggZD0iTTEwIDE1aC4wMSIgLz4KICA8cGF0aCBkPSJNMTQgMTl2LTdDMTQgNiA5IDIgOCAyUzIgNiAyIDEydjdoMTRhMiAyIDAgMCAwIDItMlY4YTIgMiAwIDAgMSA0IDB2OSIgLz4KICA8cGF0aCBkPSJNMyAyMmgxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/iron
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const iron: IconNode = [
  ['path', { d: 'M8 7h.01', key: '1vti4s' }],
  ['path', { d: 'M6 11h.01', key: 'zu6c92' }],
  ['path', { d: 'M10 11h.01', key: 'd2at3l' }],
  ['path', { d: 'M6 15h.01', key: 'ectzsy' }],
  ['path', { d: 'M10 15h.01', key: '44in9x' }],
  [
    'path',
    { d: 'M14 19v-7C14 6 9 2 8 2S2 6 2 12v7h14a2 2 0 0 0 2-2V8a2 2 0 0 1 4 0v9', key: '10jlb4' },
  ],
  ['path', { d: 'M3 22h10', key: 's0j7d9' }],
];

export default iron;
